import { consumeWatcherLocation } from "./watcherLinks";

// This module is the first entrypoint dependency, before Sentry and Elm.
export const watcherLocation = consumeWatcherLocation(window.location, window.history);
